// src/modules/COGS/DashboardTab.js
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { motion } from 'framer-motion';
import 'chart.js/auto';

const DashboardTab = ({ items }) => {
  const averageItemCostPercentage = (items.reduce((acc, item) => acc + (item.cost / item.price) * 100, 0) / items.length).toFixed(2);
  const totalStoresBreakeven = 15000; // This should be calculated or fetched from actual data
  const itemsInSpecials = 3; // This should be calculated or fetched from actual data
  const cogsImprovementRate = -2.5; // This should be calculated based on historical data

  const bestItems = [...items].sort((a, b) => b.margin - a.margin).slice(0, 3);
  const worstItems = [...items].sort((a, b) => a.margin - b.margin).slice(0, 3);

  const cogsData = {
    labels: items.map(item => item.name),
    datasets: [
      {
        label: 'COGS %',
        data: items.map(item => ((item.cost / item.price) * 100).toFixed(2)),
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
      },
      {
        label: 'Margin %',
        data: items.map(item => item.margin),
        backgroundColor: 'rgba(153, 102, 255, 0.6)',
      }
    ],
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        <motion.div 
          className="bg-white p-6 rounded-lg shadow-lg"
          whileHover={{ scale: 1.05 }}
        >
          <h2 className="text-xl font-semibold mb-2">Average Item Cost</h2>
          <p className="text-4xl font-bold text-blue-500">{averageItemCostPercentage}%</p>
        </motion.div>
        <motion.div 
          className="bg-white p-6 rounded-lg shadow-lg"
          whileHover={{ scale: 1.05 }}
        >
          <h2 className="text-xl font-semibold mb-2">Total Stores Breakeven</h2>
          <p className="text-4xl font-bold text-green-500">${totalStoresBreakeven.toLocaleString()}</p>
        </motion.div>
        <motion.div 
          className="bg-white p-6 rounded-lg shadow-lg"
          whileHover={{ scale: 1.05 }}
        >
          <h2 className="text-xl font-semibold mb-2">Items in Specials</h2>
          <p className="text-4xl font-bold text-purple-500">{itemsInSpecials}</p>
        </motion.div>
        <motion.div 
          className="bg-white p-6 rounded-lg shadow-lg"
          whileHover={{ scale: 1.05 }}
        >
          <h2 className="text-xl font-semibold mb-2">COGS Improvement Rate</h2>
          <p className="text-4xl font-bold text-yellow-500">{cogsImprovementRate}%</p>
        </motion.div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <div className="bg-white p-6 rounded-lg shadow-lg">
          <h2 className="text-xl font-semibold mb-4">Best Performing Items</h2>
          <Bar 
            data={{
              labels: bestItems.map(item => item.name),
              datasets: [{
                label: 'Margin %',
                data: bestItems.map(item => item.margin),
                backgroundColor: 'rgba(75, 192, 192, 0.6)',
              }]
            }} 
            options={{
              scales: {
                y: {
                  beginAtZero: true,
                  max: 100,
                }
              }
            }}
          />
        </div>
        <div className="bg-white p-6 rounded-lg shadow-lg">
          <h2 className="text-xl font-semibold mb-4">Items Needing Improvement</h2>
          <Bar 
            data={{
              labels: worstItems.map(item => item.name),
              datasets: [{
                label: 'Margin %',
                data: worstItems.map(item => item.margin),
                backgroundColor: 'rgba(255, 99, 132, 0.6)',
              }]
            }}
            options={{
              scales: {
                y: {
                  beginAtZero: true,
                  max: 100,
                }
              }
            }}
          />
        </div>
      </div>

      <div className="bg-white p-6 rounded-lg shadow-lg mb-6">
        <h2 className="text-xl font-semibold mb-4">COGS Overview</h2>
        <Bar 
          data={cogsData}
          options={{
            scales: {
              y: {
                beginAtZero: true,
                max: 100,
              }
            }
          }}
        />
      </div>
    </>
  );
};

export default DashboardTab; 